import React from 'react'

const TabletRequirements = (props) => {
  return (
    <div className="tab">
      <h2>Tablet Requirements</h2>
      <div className="supportTable">
        <div className="row columnHeader">
          <div className="column leftAlign">Device</div>
          <div className="column leftAlign">OS Version</div>
          <div className="column leftAlign">Browser</div>
        </div>
        <div className="row leftAlign">
          <div className="column leftAlign">Apple iPad</div>
          <div className="column leftAlign">iOS 10 and newer</div>
          <div className="column leftAlign">Safari</div>
        </div>
        <div className="row leftAlign">
          <div className="column leftAlign">Android Tablet</div>
          <div className="column leftAlign">Android 4.4 and newer</div>
          <div className="column leftAlign">Chrome</div>
        </div>
      </div>
    </div>
  )
}

export default TabletRequirements
